'use client';

import React from "react";
import { Users } from "lucide-react";
import { useTeam } from "../internals";

export const EmptyState = ({ onInvite }) => {
  const { copy, currentUser } = useTeam();
  const canInvite = ["owner", "admin", "manager"].includes(currentUser.role);
  return (
    <div
      data-testid="team-empty-state"
      className="rounded-xl border border-dashed border-zinc-300 bg-white px-6 py-12 text-center"
    >
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-zinc-100">
        <Users size={22} className="text-zinc-500" />
      </div>
      <h3 className="mt-4 text-base font-semibold text-zinc-900">{copy.empty_title}</h3>
      <p className="mt-1 text-sm text-zinc-500">{copy.empty_body}</p>
      {canInvite && (
        <button
          type="button"
          data-testid="team-empty-invite-btn"
          onClick={onInvite}
          className="mt-5 inline-flex items-center rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700"
        >
          {copy.cta_invite}
        </button>
      )}
    </div>
  );
};
